export class ClientDeleteModel {
    engagementId: number;
    clientId: number;
    status: string;
}